import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { Provider } from 'react-redux';
import store from '@redux/store';
import { AuthProvider } from '@context/index';
import NiceModal from '@ebay/nice-modal-react';
import { ToastContainer } from 'react-toastify';
import Spinner from '@util/spinner';
import RouteProgress from '@components/RouteProgress';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import '../styles/global.css';
import '../styles/normalize.css';
import '../styles/stylesheet.css';
import '@solana/wallet-adapter-react-ui/styles.css';
import '@rainbow-me/rainbowkit/styles.css';
import '../components/Landing/allLogin.css';
import '../components/PlayGameController/index.css';
import '../components/PlayGameController/testDriveLoadingScreen.css';
import '../components/Drives/OpenWorldMenu/OpenWorldMenu.css';
import '../components/KeyBinding/ControlRemoteKeyBinding/index.css';
import '../components/KeyBinding/KeyboardKeyBinding/index.css';
import '../components/KeyBinding/WheelKeybinding/index.css';
import '../components/activate/NftAccount.css';
import '../components/Drives/index.css';
import '../components/OwnerDrive/index.css';
import '../components/OwnerDrive/ScavengerHunt/drop-reached-message.css';
import '../components/Owner/ScoreUnScoreDrive/Spinner.css';
import '../components/Owner/Geofences/Map.css';
import '../components/NewPlayGame/newPlayGame.css';
import '../components/GamePass/index.css';
import '../components/DiscordLogin/discord.css';
import '../components/Dashboard/KYC/shuftiProIntro.css';
import '../components/Dashboard/KYC/ShufiProStart.css';
import '../components/Dashboard/KYC/kycPage.css';
import '../components/BotTestDrive/index.css';
import '../context/base.css';

// Suppress non-critical runtime errors that show in Next.js dev overlay.
// These existed in Gatsby but were hidden as console warnings.
// Agora RTM timeouts in particular fire when navigating away from drive
// pages — they're not actionable.
if (typeof window !== 'undefined') {
	const isNonCriticalError = (msg) =>
		typeof msg === 'string' && (
			msg.includes('DEVICE_NOT_FOUND') ||
			msg.includes('AgoraRTCException') ||
			msg.includes('NotFoundError') ||
			msg.includes('RtmTimeoutError') ||
			msg.includes('RTM:ERROR') ||
			msg.includes('Error Code 4')
		);

	window.addEventListener('unhandledrejection', (event) => {
		const msg = event?.reason?.message || event?.reason || '';
		if (isNonCriticalError(msg)) {
			event.preventDefault();
			console.warn('[Agora]', msg);
		}
	});

	window.addEventListener('error', (event) => {
		const msg = event?.message || event?.error?.message || '';
		if (isNonCriticalError(msg)) {
			event.preventDefault();
			console.warn('[Agora]', msg);
			return true;
		}
	});
}

/**
 * Most pages read localStorage during render (auth token, drivingBot, etc.). On
 * the server those reads return null and on the client they return real values,
 * which causes hydration mismatches. Rendering pages only after mount avoids the
 * mismatch by making the server HTML and the first client paint identical
 * (a Spinner). Pages then mount client-side, where localStorage is available.
 */
const App = ({ Component, pageProps }) => {
  const [mounted, setMounted] = useState(false);
  const getLayout = Component.getLayout ?? ((page) => page);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Provider store={store}>
      <NiceModal.Provider>
        <AuthProvider>
          <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          </Head>
          <RouteProgress />
          <ToastContainer />
          {mounted ? getLayout(<Component {...pageProps} />) : <Spinner loading />}
        </AuthProvider>
      </NiceModal.Provider>
    </Provider>
  );
};

export default App;
